import React from "react";
import brochurePdf from "../../assets/browcher.pdf";   
import brochureImg from "../../assets/browcher.jpg";  
import poster from "../../assets/poster.jpg";

const CollegeDetails = () => {
  return (
    <div 
      className="relative min-h-screen p-10 overflow-hidden"
      id="college-details"
    >
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-100 via-purple-100 to-pink-100"></div>

      {/* Optional Decorative Radial Glow */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-pink-300/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-300/30 rounded-full blur-3xl"></div>

      {/* Content */}
      <div className="relative container mx-auto max-w-5xl">
        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-12 
          bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 
          drop-shadow-lg tracking-wide">
          About Yantra
        </h1>

        {/* About Yantra Section */}
        <div className="bg-white/80 shadow-xl rounded-3xl p-10 mb-12 backdrop-blur-sm border border-gray-200 hover:shadow-2xl transition">
          <p className="text-gray-700 leading-relaxed text-lg mb-4">
            The pioneer of technology. The Mechanical Engineer’s endeavour proved again
            through <span className="font-bold text-blue-600">YANTRA</span>. 
            <em className="text-purple-600"> “Man made by Mechanisms, World ruled by Mechanicals” </em> 
            is the tagline of <span className="font-bold text-blue-600">YANTRA</span>.
          </p>
          <p className="text-gray-700 leading-relaxed text-lg mb-4">
            Yeah, the man is made up of many mechanisms. Can you imagine life without proper
            mechanisms? And similarly, can you imagine life from ancient man to modern man 
            without the involvement of mechanical engineering? Of course not! 
          </p>
          <p className="text-gray-700 leading-relaxed text-lg mb-4">
            To this ancient art of engineering many significant changes took place. 
            To know the latest technological developments, it is necessary to build a platform 
            for exchange of knowledge, one such platform is our symposium.
          </p>
          <p className="text-gray-700 leading-relaxed text-lg mb-6">
            <span className="font-bold text-blue-600">YANTRA</span> is one such symposium inviting all budding knowledge 
            enthusiasts and engineers to share and explore the possibilities of understanding 
            the contemporary technical advancements.
          </p>
          
          <h3 className="text-2xl font-bold mb-4 text-gray-800">
            Events at the symposium:
          </h3>
          <ul className="grid sm:grid-cols-2 gap-3 text-gray-700 text-lg">
            <li className="flex items-center">📑 Paper / PowerPoint Presentations</li>
            <li className="flex items-center">🔬 Project Exhibitions</li>
            <li className="flex items-center">🛠 Workshops</li>
            <li className="flex items-center">🎨 Poster Presentations</li>
            <li className="flex items-center">💡 Innovative Models</li>
            <li className="flex items-center">⚡ Spot Events</li>
            <li className="flex items-center">🎶 Cultural Night</li>
          </ul>
        </div>

        {/* Poster Section */}
        <div className="bg-white/90 shadow-xl rounded-3xl p-8 mb-12 hover:shadow-2xl transition transform hover:-translate-y-1">
          <h2 className="text-3xl font-semibold text-center p-3 mb-6 
            bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl shadow-md">
            Event Poster
          </h2>
          <img
            src={poster}
            alt="Event Poster"
            className="w-full rounded-2xl shadow-md hover:scale-105 transition-transform duration-500"
          />
          <p className="mt-6 text-gray-700 text-center text-lg font-medium">
            Download our event poster to learn more about our upcoming events and activities.
          </p>
          <div className="mt-6 text-center">
            <a
              href={poster}
              download
              className="inline-block bg-gradient-to-r from-blue-600 to-indigo-600 
              text-white py-3 px-8 rounded-full hover:from-blue-700 hover:to-indigo-700 
              transition duration-300 shadow-lg hover:shadow-xl"
            >
              ⬇ Download Poster
            </a>
          </div>
        </div>

        {/* Brochure Section */}
        <div className="bg-white/90 shadow-xl rounded-3xl p-8 mb-12 hover:shadow-2xl transition transform hover:-translate-y-1">
          <h2 className="text-3xl font-semibold text-center p-3 mb-6 
            bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl shadow-md">
            Event Brochure
          </h2>
          <img
            src={brochureImg}
            alt="Event Brochure Preview"
            className="w-full rounded-2xl shadow-md hover:scale-105 transition-transform duration-500"
          />
          <p className="mt-6 text-gray-700 text-center text-lg font-medium">
            Download our event brochure to explore all event details and activities.
          </p>
          <div className="mt-6 text-center">
            <a
              href={brochurePdf}
              download
              className="inline-block bg-gradient-to-r from-pink-500 to-red-500 
              text-white py-3 px-8 rounded-full hover:from-pink-600 hover:to-red-600 
              transition duration-300 shadow-lg hover:shadow-xl"
            >
              ⬇ Download Brochure
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollegeDetails;
